export enum PRICING_CALCULATE_TYPE {
  PER_AREA = 'PER_AREA',
  STATIC = 'STATIC'
}

export enum PRICE_CHANGE_TYPE {
  PERCENTAGE = 'PERCENTAGE',
  PRICE = 'PRICE'
}

export enum PRICE_INCREASE_TYPE {
  INCREMENT = 'INCREMENT',
  DECREMENT = 'DECREMENT'
}

export enum FLOOR_POSITION {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM'
}

export enum ENTRANCE_POSITION {
  AFTER = 'AFTER',
  BEFORE = 'BEFORE'
}

export enum FIELD_TYPE {
  TEXT = 'TEXT',
  DATE = 'DATE',
  SELECT = 'SELECT',
  MULTI_SELECT = 'MULTI_SELECT',
  URL = 'URL',
  TOGGLE_SWITCH = 'TOGGLE_SWITCH',
  RADIO = 'RADIO'
}

export enum STATUS {
  SALE = 'SALE',
  BOOKED = 'BOOKED',
  SOLD = 'SOLD',
  RESERVE = 'RESERVE'
}

export enum POSITION {
  FLAT_PLAN = 'FLAT_PLAN',
  FLAT_FLOOR = 'FLAT_FLOOR',
  FLAT_3D = 'FLAT_3D',
  FLAT_EXTRA = 'FLAT_EXTRA',
  HOUSE_PLAN = 'HOUSE_PLAN',
  HOUSE_MAIN = 'HOUSE_MAIN',
  HOUSE_3D = 'HOUSE_3D',
  HOUSE_EXTRA = 'HOUSE_EXTRA',
  HOUSE_LOGO = 'HOUSE_LOGO',
  CLIENT_PASSPORT_FRONT = 'CLIENT_PASSPORT_FRONT',
  CLIENT_PASSPORT_BACK = 'CLIENT_PASSPORT_BACK',
  CLIENT_PASSPORT_EXTRA = 'CLIENT_PASSPORT_EXTRA',
  FLAT_GEN_PLAN = 'FLAT_GEN_PLAN',
  FLAT_VIDEO = 'FLAT_VIDEO',
  FLAT_PART_VIDEO = 'FLAT_PART_VIDEO',
  FLAT_DOCUMENT = 'FLAT_DOCUMENT',
  FLAT_PART_DOCUMENT = 'FLAT_PART_DOCUMENT'
}
